import { render, staticRenderFns } from "./person-info-popover.vue?vue&type=template&id=437407b4&scoped=true&"
import script from "./person-info-popover.vue?vue&type=script&lang=js&"
export * from "./person-info-popover.vue?vue&type=script&lang=js&"
import style0 from "./person-info-popover.vue?vue&type=style&index=0&id=437407b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437407b4",
  null
  
)

export default component.exports